<ng-container *ngIf="isShow">
  <div class="container-context-menu">
    <div class="wrapper-context-menu"
         [@slide]="slideAnimationPopup"
         (@slide.done)="onSlidePopupAnimation($event)">
      <ng-container *ngTemplateOutlet="typeOfTemp"></ng-container>
      <div class="overlay" (click)="isShow = false"></div>
    </div>
  </div>
</ng-container>

<ng-template #menu_item>
  <ul>
    <li (click)="play()"><span>پخش</span></li>
    <li (click)="RouteToPdp()"><span>نمایش اطلاعات اثر</span></li>
    <li *ngIf="parameterService.clientId !== clientTypeEnum.iGap" (click)="share()"><span>ارسال به دیگران</span></li>
    <li (click)="remove()" *ngIf="tab == 'library' || tab == 'bookmark'"><span>حذف از لیست</span></li>
  </ul>
</ng-template>

<ng-template #remove_dialog_bookmark>
  <div class="popup">
    <div class="header-popup">
        <span>
            حذف از نشان شده ها
        </span>
    </div>
    <div class="popup-content">
      <span>آیا از پاک کردن این کتاب صوتی از لیست نشان شده ها اطمینان دارید؟</span>
      <br/>
      <br/>
    </div>
    <div class="popup-actions">
      <button
        class="button-actions"
        (click)="removeBookmark()"
        [disabled]="isDisable"
      >
        تایید
      </button>
      <button
        class="button-actions"
        (click)="cancel()"
      >
        انصراف
      </button>
    </div>
  </div>
</ng-template>

<ng-template #remove_dialog_library>
  <div class="popup">
    <div class="header-popup">
        <span>
          {{subscriptionStatus.isSubscriptionConsumption ? 'حذف از لیست' : 'انتقال به بایگانی'}}
        </span>
    </div>
    <div class="popup-content">
      <ng-template [ngIf]="subscriptionStatus.isSubscriptionConsumption" [ngIfElse]="hasSub_message">
        <p>آیا از حذف این محتوا مطمئن هستید؟</p>
        <span>شما همواره میتوانید در مدت فعال بودن اشتراک خود، این محتوا را مجددا  بدون پرداخت وجه، دوباره به کتابخانه برگردانید.</span>
      </ng-template>
      <ng-template #hasSub_message>
        <p>آیا از انجام این انتقال مطمئن هستید؟</p>
        <span>با انتقال به بایگانی، محتوای مورد نظر از دستگاه و کتابخانه حذف خواهد شد. البته شما همواره میتوانید، از قسمت بایگانی بدون پرداخت وجه، دوباره به کتابخانه برگردانید.</span>
      </ng-template>
    </div>
    <div class="popup-actions">
      <button
        class="button-actions"
        (click)="removeLibrary()"
        [disabled]="isDisable"
      >
        تایید
      </button>
      <button
        class="button-actions"
        (click)="cancel()"
      >
        انصراف
      </button>
    </div>
  </div>
</ng-template>

<ng-template #end_subscription>
  <div class="status-subscription">
    <div class="status-subscription-header">
     <span (click)="cancel()">
       <ng-container *ngTemplateOutlet="close_icon"></ng-container>
     </span>
      <navaar-lock-icon style="display: inline-block; width: 60px"></navaar-lock-icon>
    </div>
    <div class="status-subscription-body">
      <p>زمان اشتراک شما به پایان رسیده است. با تمدید آن میتوانید به محتوای مورد نظر دسترسی پیدا کنید.</p>
    </div>
    <div class="status-subscription-footer">
      <navaar-button
        [type-button]="'button'"
        [color-name]="'orange'"
        (onClick)="goToSubscription()"
      >
                  <span
                    [textContent]="'تمدید اشتراک'"
                  ></span>
      </navaar-button>
    </div>
  </div>
</ng-template>

<ng-template #close_icon>
  <svg xmlns="http://www.w3.org/2000/svg" width="16.705" height="16.581" viewBox="0 0 16.705 16.581">
    <g id="Group_3861" data-name="Group 3861" transform="translate(-58.086 -164.086)" opacity="0.504">
      <g id="Group_3859" data-name="Group 3859" transform="translate(4152 79)">
        <line id="Line_315" data-name="Line 315" x1="6.876" y2="6.876" transform="translate(-4085.5 86.5)" fill="none"
              stroke="#fff" stroke-linecap="round" stroke-width="2"/>
        <line id="Line_316" data-name="Line 316" x1="6.876" y1="6.876" transform="translate(-4085.5 93.376)" fill="none"
              stroke="#fff" stroke-linecap="round" stroke-width="2"/>
      </g>
      <g id="Group_3860" data-name="Group 3860" transform="translate(59.5 165.5)">
        <line id="Line_315-2" data-name="Line 315" x2="6.876" y2="6.876" transform="translate(0)" fill="none"
              stroke="#fff" stroke-linecap="round" stroke-width="2"/>
        <line id="Line_316-2" data-name="Line 316" y1="6.876" x2="6.876" transform="translate(0 6.876)" fill="none"
              stroke="#fff" stroke-linecap="round" stroke-width="2"/>
      </g>
    </g>
  </svg>
</ng-template>
